export default __webpack_public_path__ + "static/media/mrs.8ba40665.png";